// Is this server row what the store already holds?
//
// Every store used to mark every row of its kinds changed on every poll, so
// every 10 s every subscriber in the app re-rendered over a dump that had not
// moved. The stores now ask this first and change (and notify) only when the
// answer is no.
//
// COMPARED WITH WHAT THE STORE HOLDS, NOT WITH THE LAST DUMP. The two differ
// exactly when this tab has drifted from the server without a pending write to
// explain it — a DELETE that was refused after the row was dropped locally
// (store-persist.ts `forget`), a grade echoed from /api/grade with fields the
// dump leaves out. Today's poll heals each of those on the next tick, and it
// must keep doing so: comparing against the last dump would call the server's
// unchanged row "nothing new" and leave the tab wrong until a reload.
//
// A FALSE "different" costs one re-render, never correctness — the row is then
// set to the server's copy, and the next poll compares equal. So this only has
// to be right about JSON values: what a dump can carry. `undefined` and a missing
// key are the same (JSON drops both), and key order does not matter (a row
// written by the server and the same row built in a tab can disagree on it).

export function sameData(a: unknown, b: unknown): boolean {
  if (a === b) return true;
  if (a === null || b === null || typeof a !== "object" || typeof b !== "object") return false;
  if (Array.isArray(a) !== Array.isArray(b)) return false;
  if (Array.isArray(a)) {
    const bs = b as unknown[];
    if (a.length !== bs.length) return false;
    for (let i = 0; i < a.length; i++) if (!sameData(a[i], bs[i])) return false;
    return true;
  }
  const ao = a as Record<string, unknown>;
  const bo = b as Record<string, unknown>;
  let defined = 0;
  for (const k in ao) {
    if (ao[k] === undefined) continue;
    defined++;
    if (!sameData(ao[k], bo[k])) return false;
  }
  for (const k in bo) if (bo[k] !== undefined) defined--;
  return defined === 0;
}
